module.exports = __webpack_public_path__ + "static/media/phone-alt.2242cb8c.svg";